import { CropType, TagAlignment, TagLayout } from '@app/common/settings-components/types';

export const TAG_LAYOUT_AI_DESCRIPTION = `
        The layout type for the tags.
        Possible values:
        - ${TagLayout.Button} Each tag is presented as a button.
        - ${TagLayout.Text} Each tag is presented as text.
        `;

export const CROP_TYPE_AI_DESCRIPTION = `
        The image crop type.
        Possible values:
        - ${CropType.Crop} Crop the image to fit.
        - ${CropType.Fit} Fit the image without cropping.
        `;

export const TAG_ALIGNMENT_AI_DESCRIPTION = `
        The tag alignment.
        Possible values:
        - ${TagAlignment.Left} Left alignment.
        - ${TagAlignment.Center} Center alignment.
        - ${TagAlignment.Right} Right alignment.
        `;
